import { defineNuxtPlugin, useRuntimeConfig } from "#imports";
import Rollbar from "rollbar";

const isValidAccessToken = (accessToken: unknown): accessToken is string => {
    return typeof accessToken === "string" && accessToken.length > 0;
};

export default defineNuxtPlugin((nuxtApp) => {
    const config = useRuntimeConfig();
    const { clientAccessToken, config: rollbarConfig } = config.public.rollbar;
    const serverAccessToken = config.__rollbarServerAccessToken;

    const accessToken = import.meta.client ? clientAccessToken : serverAccessToken;

    if (!isValidAccessToken(accessToken)) {
        const side = import.meta.client ? "client" : "server";
        return console.error(
            `Skipping Rollbar initialization on ${side} side. Please provide a valid ${side}AccessToken.`
        );
    }

    const rollbar = new Rollbar({
        ...rollbarConfig,
        accessToken,
        payload: {
            ...rollbarConfig?.payload,
            client: {
                javascript: {
                    code_version: config.public.releaseVersion as string | undefined,
                },
            },
        },
    });

    // Called when a fatal error occurs
    nuxtApp.hook("app:error", (error) => {
        rollbar.error(error as Error);
    });

    return {
        provide: { rollbar },
    };
});
